import React from 'react';
import { connect } from '@gasbuddy/react';
import { Col } from 'react-bootstrap';
import MainLayout from '../../components/main-layout';
import StationListSelector from '../../components/station-list-selector';
import { StationListResponseType } from '../../../../legacy/src/scripts/enums';

/* eslint-disable react/prefer-stateless-function */
class Home extends React.Component {
  // b/c the MainLayout is required to have children components (markup inside the component tag)
  // we put this <div> does nothing, it will be removed at a later time when we have only components to put inside of it
  render() {
    return (
      <MainLayout title="Dashboard Summary">
        <Col xs={12} sm={6} md={4} style={{ padding: '0px' }}>
          <StationListSelector
            stationListResponseType={StationListResponseType.no_stations}
          />
        </Col>
      </MainLayout>
    );
  }
}

export default connect()(Home);
